import { CompanyProfileTabProps } from "./OverviewTab";
import AddressesTab from "./AddressesTab";
import BankingTab from "./BankingTab";
import CertificationsTab from "./CertificationsTab";

/**
 * The "Company Data" tab (second tab) — stacks the Addresses / Banking / Certifications sections,
 * each now a Carbon DataTable. Files are no longer a separate "Tax Documents" section here: the
 * Overview tab's Files table covers every file type (including tax documents) via its Type column.
 */
const CompanyDataTab = ({ companyProfile }: CompanyProfileTabProps) => (
  <div className="company-profile__company-data">
    <AddressesTab companyProfile={companyProfile} />
    <BankingTab companyProfile={companyProfile} />
    <CertificationsTab companyProfile={companyProfile} />
  </div>
);

export default CompanyDataTab;
